import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { useQuery } from "@tanstack/react-query";

export const useGetFruitPicks = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.FRUIT_PICKS],
    staleTime: QueryStaleTime.MEDIUM,
    queryFn: async () => {
      const { data } = await MealsService.getFruitPicksApiV1MealsFruitPicksGet();
      return data;
    },
  });

  return { fruitPicks: data, isLoading, isError, error, refetch };
};
